const longAnswer = 150;

/**
 * Guesses whether an answer holds more than one fact: it is long, spans
 * several lines, lists items or has two commas or more. A guess only decides
 * whether to suggest splitting the card.
 */
export function looksCompound(answer: string): boolean {
  const text = answer.trim();

  return (
    text.length > longAnswer ||
    /[\n;•]/.test(text) ||
    /^\s*(?:[-*]|\d+[.)])\s/m.test(text) ||
    (text.match(/,/g) ?? []).length >= 2
  );
}
